// App-wide constants. UPPER_SNAKE_CASE per the Frontend Rules.

// localStorage keys (centralized so they're never stringly-typed across the app).
export const STORAGE_KEYS = {
  TOKEN: 'pcs_token',
  ORG_ID: 'pcs_org_id',
  // Dummy-login identity seam (INTEGRATION.md §4): the picked participant is sent
  // as X-User-Id on every request; the selected account drives the module endpoints.
  USER_ID: 'pcs_user_id',
  ACCOUNT_ID: 'pcs_account_id',
  // The plan a sponsor last opened — where "/sponsor" lands them next time.
  SPONSOR_PLAN_ID: 'pcs_sponsor_plan_id',
  THEME_MODE: 'pcs_theme_mode',
  PALETTE: 'pcs_palette',
  CARD_STYLE: 'pcs_card_style',
  LANG: 'pcs_lang',
};

// Responsive breakpoints — the ONLY three allowed (Frontend Rules §12).
export const BREAKPOINTS = {
  MOBILE: 375,
  TABLET: 768,
  LAPTOP: 1024,
};

// Top-level navigation (mirrors the prototype's NAV). `permission` gates each item.
export const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', path: '/', permission: 'VIEW_DASHBOARD' },
  { id: 'portfolio', label: 'My Portfolio', path: '/portfolio', permission: 'VIEW_PORTFOLIO' },
  { id: 'manage', label: 'Manage Account', path: '/manage', permission: 'VIEW_MANAGE_ACCOUNT' },
];

// DEPRECATED — kept as the single fallback destination, re-exported from
// config/legacyPortal.js. Every "take me to the real thing" lever now names a legacy
// ROUTE KEY instead of a URL (hooks/useLegacyPortal + config/legacyPortal.js), so a
// destination with a confirmed .aspx path deep-links straight to it and only the
// unmapped ones still land on this portal entry point. Don't add new callers.
export { PORTAL_FALLBACK_URL as PORTAL_ACTION_URL } from './legacyPortal';

// Fund fact sheets are served by the PCS brand API — the same link the legacy Relius
// portal uses (`FundSheet?tickerid=<ticker>`) — so the fund detail's "Download PDF"
// opens it in a new tab rather than generating a PDF in this app. One host in every
// environment: the sheets are published once, there is no dev/uat copy of them.
export const FUND_SHEET_URL = 'https://api.pcscapital.com/brandapi/Lookup/api/v1/FundSheet';

/** The brand-API fact-sheet URL for one fund, keyed by ticker (e.g. "VTSAX"). */
export const fundSheetUrl = (ticker) => `${FUND_SHEET_URL}?tickerid=${encodeURIComponent(ticker)}`;

// The brand API answers with `Content-Disposition: attachment`, so a viewer pointed at
// that link can only DOWNLOAD it; it does allow cross-origin reads, so the Fund Detail
// viewer fetches the bytes itself and renders a blob. Our API re-serves the same PDF
// inline (GET /portfolio/factsheet) as the viewer's fallback.
// Same default as services/api/client.js (constants can't import the client: it imports us).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v3';

/** Same-origin, inline-rendering fact-sheet URL for one fund. */
export const fundSheetViewUrl = (ticker) => `${API_BASE_URL}/portfolio/factsheet?ticker=${encodeURIComponent(ticker)}`;

// PORTAL_ACTION_URL is deliberately absent: it is now a re-export (see above), which
// is not a local binding in this module, so it cannot be named in this object.
// Import it by name from this file instead.
const CONSTANTS = {
  STORAGE_KEYS, BREAKPOINTS, NAV_ITEMS, FUND_SHEET_URL,
};
export default CONSTANTS;
